import $ from "jquery";
// render fields as individual steps
// each field generates one form and then progress happens
window.cb_addEventListener = function(obj, evt, fnc) {
  if (obj.addEventListener) {
      obj.addEventListener(evt, fnc, false);
      return true;
  } else if (obj.attachEvent) {
      return obj.attachEvent('on' + evt, fnc);
  } else {
      evt = 'on'+evt;
      if(typeof obj[evt] === 'function'){
          fnc = (function(f1,f2){
              return function(){
                  f1.apply(this,arguments);
                  f2.apply(this,arguments);
              }
          })(obj[evt], fnc);
      }
      obj[evt] = fnc;
      return true;
  }
  return false;
};
window.UpwardJobFormField = function( field, form ){
this.id = field.questionId;
this.name  = field.name;
this.label = field.label + ( field.license ? " " + field.license.charAt(0).toUpperCase() + field.license.substr(1) : "");
this.optional = field.optional;
this.qualifyingAnswers = field.qualifyingAnswers;
this.type = field.type;
this.properties = field.properties;
this.events = {
  onChange : field.onChange,
  onBlur : field.onBlur,
  onFocus : field.onFocus,
  onValidate : field.onValidate
};
this.hasInput = field.hasInput;
this.form = form;
this.render();
}
window.UpwardJobFormField.prototype.getOptions = function(){
return this.properties && this.properties.options ? this.properties.options : {};
}
window.UpwardJobFormField.prototype.attachEvents = function(ele){
if( this.events.onBlur ){ window.cb_addEventListener(ele,"blur",this.events.onBlur); }
if( this.events.onChange ){ window.cb_addEventListener(ele,"change",this.events.onChange); }
if( this.events.onFocus ){ window.cb_addEventListener(ele,"focus",this.events.onFocus); }
if( this.events.onValidate ){ window.cb_addEventListener(ele,"validate",this.events.onValidate); }
}
window.UpwardJobFormField.prototype.render = function(){
var opts = this.getOptions();
var mainDiv = document.createElement("div");
mainDiv.className = "row form-group";
var wrapper = document.createElement('div');
wrapper.className = "col-xs-12";
var lab = document.createElement("label");
lab.innerHTML = this.label;
wrapper.appendChild( lab );
switch( this.type ){
  case 'yes_no':
    var d = document.createElement('div'), d2 = document.createElement("div");
    var r = document.createElement('input'), r2 = document.createElement('input');
    r.setAttribute('type', 'radio'); r2.setAttribute('type', 'radio');
    r.setAttribute('name', 'answer'); r2.setAttribute('name', 'answer');
    r.setAttribute('id', 'JAF_V_'+this.name.replace(" ","_")+"_yes");
    r2.setAttribute('id', 'JAF_V_'+this.name.replace(" ","_")+"_no");
    r.value = "Yes"; r2.value = "No";
    if( this.optional == 'n') r.setAttribute('required', true);
    d.appendChild( r );
    d.appendChild( document.createTextNode( "Yes" ) );
    d2.appendChild( r2 );
    d2.appendChild( document.createTextNode( "No" ) );
    wrapper.appendChild( d );
    wrapper.appendChild( d2 );
  case 'radio':
    for( var i = 0; i < opts.length; i++ ){
      var cur = opts[i];
      var d = document.createElement('div');
      var r = document.createElement('input');
      r.setAttribute('type', 'radio');
      r.setAttribute('name', 'answer');
      r.setAttribute('id', 'JAF_V_'+this.name.replace(" ","_")+"_"+i);
      var textLabel = "";
      for( var x in cur ){
        r.value = x;
        textLabel = cur[x];
      }
      if( this.optional == 'n') r.setAttribute('required', true);
      d.appendChild( r );
      if( this.events.onReady ){ this.events.onReady(r); }
      d.appendChild( document.createTextNode( textLabel ) );
      wrapper.appendChild( d );
    }
    mainDiv.appendChild( wrapper );
    break;
  case 'singleselect':
    var selectList = document.createElement('select');
    selectList.className = "inputBox inputSmall";
    selectList.setAttribute('name', 'answer');
    if( this.optional == 'n') selectList.setAttribute('required', true);
    for( var i = 0; i < opts.length; i++ ){
      var option = document.createElement("option");
      var cur = opts[i];
      for( var x in cur ){
        option.text = cur[x];
        option.value = x;
      }
      selectList.appendChild( option );
    }
    this.attachEvents(selectList);
    if( this.events.onReady ){ this.events.onReady(selectList); }
    wrapper.appendChild( selectList );
    mainDiv.appendChild( wrapper );
    break;
  case 'multiselect':
  case 'multiple_choice':
    for( var i = 0; i < opts.length; i++ ){
      var cur = opts[i];
      var d = document.createElement('div');
      d.className = "clearfix";
      var r = document.createElement('input');
      r.className = 'JAF_V_'+this.name;
      r.setAttribute('type', 'checkbox');
      r.setAttribute('name', 'answer');
      r.setAttribute('id', 'JAF_V_'+this.name.replace(" ","_")+"_"+i);
      var textLabel = "";
      for( var x in cur ){
        r.value = x;
        textLabel = cur[x];
      }
      this.attachEvents(r);
      d.appendChild( r );
      if( this.events.onReady ){ this.events.onReady(); }
      d.appendChild( document.createTextNode( textLabel ) );
      wrapper.appendChild( d );
    }
    mainDiv.appendChild(wrapper);
    break;
  case 'text':
  case 'number':
    var inp = document.createElement('input');
    inp.className = "inputBox inputSmall";
    inp.setAttribute('name', 'answer');
    if( this.type == 'number' ){
      inp.setAttribute("type", "number");
    } else {
      inp.setAttribute("type", "text");
    }
    if( this.optional == 'n') inp.setAttribute('required', true);
    this.attachEvents(inp);
    if( this.events.onReady ){ this.events.onReady(inp); }
    wrapper.appendChild( inp );
    mainDiv.appendChild( wrapper );
    break;
}
var jafId = document.createElement("input"), jafF = document.createElement("input"), jafL = document.createElement("input"), jafQA = document.createElement("input");
jafId.setAttribute("type","hidden"); jafF.setAttribute("type","hidden"); jafL.setAttribute("type","hidden"); jafQA.setAttribute("type","hidden");
jafId.setAttribute("name","id"); jafF.setAttribute("name","question"); jafL.setAttribute("name","label"); jafQA.setAttribute("name","qualifyingAnswers");
jafId.value = this.id; jafF.value = this.name; jafL.value = this.label; jafQA.value = this.qualifyingAnswers;
mainDiv.appendChild( jafId );
mainDiv.appendChild( jafF );
mainDiv.appendChild( jafL );
mainDiv.appendChild( jafQA );
this.mainElement = mainDiv;
}
window.UpwardJobForm = function( jobId, companyId, field, handler ){
this.jobId = jobId;
this.companyId = companyId;
this.id = field.questionId || null;
this.label = field.label || "";
this.onSubmit = field.onSubmit;
this.onValidate = field.onValidate;
this.field = new window.UpwardJobFormField( field , this );
this.element = null;

var loadingDiv = document.createElement("div");
loadingDiv.className = 'loading';
loadingDiv.innerHTML = '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
this.loading = loadingDiv;
this.handler = handler;
}
window.UpwardJobForm.prototype.render = function(){
var d = document.createElement("div");
d.className = "clearfix";
var f = document.createElement("form");
f.appendChild( this.field.mainElement );
var btnWrap = document.createElement("div");
btnWrap.className = "form-actions";
btnWrap.innerHTML = '<div class="text-center"><button type="submit" class="btn btnSmall altBg fullwidth btn-block">Submit</button></div>';
btnWrap.appendChild( this.loading );
f.appendChild( btnWrap );
d.appendChild(f);
this.form = f;
this.element = d;
this.attachEvents();
}
window.UpwardJobForm.prototype.serialize = function(){
var data = new FormData( this.form );
var postData = {};
if( this.type === 'multiple_choice'){

} else {
  for (var value of data.keys()) {
    postData[ value ] = data.get(value);
  }
}
return postData;
}
window.UpwardJobForm.prototype.handleFormSubmit = function( event ){
this.loading.classList.add("in");
this.handler.handleSubmit( this.serialize() );
event.preventDefault();
event.stopPropagation();
}
window.UpwardJobForm.prototype.attachEvents = function(){
var local = this;
this.form.addEventListener("submit", function(event){ local.handleFormSubmit( event ); } );
}
window.UpwardJobForm.prototype.destroy = function(){
this.loading.classList.remove("in");
this.f = null;
this.d = null;
}

window.UpwardFormHandler = function( formJson ){
  this.currentFormIndex = 0;
  this.currentForm = null;
  this.forms = [];
  this.formData = [];
  if( ! formJson.jobId || !formJson.fields ){
    this.goNext();
    return;
  }
  this.jobId = formJson.jobId || null;
  this.companyId = formJson.companyId || null;
  this.firstName = formJson.firstName || null;
  this.lastName = formJson.lastName || null;
  this.phoneNumber = formJson.phoneNumber || null;
  this.address3 = formJson.address3 || null;
  this.jobLocation = formJson.jobLocation || null;
  this.jobTitle = formJson.jobTitle || null;
  this.companyName = formJson.companyName || null;
  this.applyDate = formJson.applyDate || null;
  var fields = formJson.fields;
  if( fields && fields.length ){
    for( var i = 0; i < fields.length; i ++ ){
      this.forms.push( new window.UpwardJobForm( this.jobId, this.companyId, fields[i], this ) );
    }
  }
}
window.UpwardFormHandler.prototype.handleSubmit = function( data ){
var local = this;
setTimeout( function(){
  local.formData.push( data );
  local.currentForm.destroy();
  var ele = document.getElementById("deJobFormWrapper");
  while( ele.firstChild ){
    ele.removeChild( ele.lastChild );
  }
  local.goNext();
}, 1000);
}
window.UpwardFormHandler.prototype.submitAllData = function(){
var local = this;
var postData = {};
postData.jobId = this.jobId;
postData.firstName = this.firstName;
postData.lastName = this.lastName;
postData.companyId = this.companyId;
postData.phoneNumber = this.phoneNumber;
postData.address3 = this.address3;
postData.jobLocation = this.jobLocation;
postData.jobTitle = this.jobTitle;
postData.companyName = this.companyName;
postData.applyDate = this.applyDate;
postData.source = "API";
postData.function = "add_lead";
postData.dnc_check = "Y";
postData.duplicate_check = "DUPLIST";
postData.list_id = 600001;
postData.add_to_hopper = "Y";
postData.custom_fields = "Y";
this.formData[0].label = this.formData[0].label.replace( /(<([^>]+)>)/ig, '');
postData.formData = JSON.stringify( this.formData );
$.ajax({
  url : process.env['REACT_APP_API_URL'] + "/upward/applicantQuestionSubmit.jsp",
method : "GET",
  type: 'GET',
  data: postData,
  async: false,
  cache: false,
}).then(function(data){
});
}
window.UpwardFormHandler.prototype.goNext = function(){
this.currentFormIndex++;
if( this.currentFormIndex < this.forms.length ){
  this.render();
} else {
  this.currentFormIndex = 0;
  this.submitAllData();
  $('#registerOverlayWrapper').addClass('hide');
  $('#addResumeModal').modal({'backdrop':false,"keyboard":false,"show":true});
}
}
window.UpwardFormHandler.prototype.render = function(){
this.currentForm = this.forms[this.currentFormIndex];
this.currentForm.render();
document.getElementById("deJobFormWrapper").appendChild( this.currentForm.element );
}
